import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  BootstrapSizes,
  Box,
  Button,
  ButtonColors,
  Modal,
} from "@talentech/components";
import CustomAssetManager from "@/components/MediaLibrary/MediaLibrary";

interface BannerPickerProps {
  value: string;
  onChange: (url: string) => void;
}

const BannerPicker: React.FC<BannerPickerProps> = ({ value, onChange }) => {
  const [showModal, setShowModal] = useState(false);

  const onSelect = (src: string) => {
    if (/\.mp4$/i.test(src)) {
      toast.error("Choose an image, not a video");
      return;
    }
    onChange(src);
    setShowModal(false);
  };

  return (
    <Box>
      {value && (
        <img
          src={`${value}?width=400`}
          alt="Banner image"
          className="img-fluid rounded border mb-2 d-block"
          style={{ maxHeight: 160 }}
        />
      )}
      <Box flex className="gap-2">
        <Button
          label={value ? "Change image" : "Choose image"}
          outline
          color={ButtonColors.PRIMARY}
          icon={<i className="fa-sharp fa-light fa-images me-2" />}
          onClick={() => setShowModal(true)}
        />
        {value && (
          <Button
            label="Remove"
            outline
            color={ButtonColors.DANGER}
            onClick={() => onChange("")}
          />
        )}
      </Box>

      <Modal
        title="Choose banner image"
        showModal={showModal}
        size={BootstrapSizes.XLARGE}
        onClose={() => setShowModal(false)}
        buttons={[
          <Button
            key="cancel"
            label="Cancel"
            outline
            color={ButtonColors.PRIMARY}
            onClick={() => setShowModal(false)}
          />,
        ]}
      >
        {showModal && <CustomAssetManager onSelect={onSelect} />}
      </Modal>
    </Box>
  );
};

export default BannerPicker;
